import { Injectable } from '@angular/core';

@Injectable()
export class ConsoleService {

  public log(m: any): void { return; }
  public debug(m: any): void { return; }
  public error(m: any): void { return; }
  public warn(m: any): void { return; }
  public info(m: any): void { return; }

}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/console.service.ts